import {initializeApp} from "firebase/app";
import {getAuth} from "firebase/auth";
import {getMessaging} from "firebase/messaging";

// Firebase Web config is public. Firebase Admin credentials must remain API-only.
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const firebaseVapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;

const requiredFirebaseVariables = {
  REACT_APP_FIREBASE_API_KEY: firebaseConfig.apiKey,
  REACT_APP_FIREBASE_AUTH_DOMAIN: firebaseConfig.authDomain,
  REACT_APP_FIREBASE_PROJECT_ID: firebaseConfig.projectId,
  REACT_APP_FIREBASE_STORAGE_BUCKET: firebaseConfig.storageBucket,
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID: firebaseConfig.messagingSenderId,
  REACT_APP_FIREBASE_APP_ID: firebaseConfig.appId,
  REACT_APP_FIREBASE_VAPID_KEY: firebaseVapidKey,
};

const missingFirebaseVariables = Object.entries(requiredFirebaseVariables)
  .filter(([, value]) => !value)
  .map(([name]) => name);

if (missingFirebaseVariables.length > 0) {
  throw new Error(
    `Configuration Firebase manquante: ${missingFirebaseVariables.join(", ")}`,
  );
}

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const messaging = getMessaging(app);

const registerMessagingServiceWorker = async () => {
  if (!("serviceWorker" in navigator)) return null;

  const firebaseConfigParam = encodeURIComponent(JSON.stringify(firebaseConfig));

  try {
    return await navigator.serviceWorker.register(
      `/firebase-messaging-sw.js?firebaseConfig=${firebaseConfigParam}`,
    );
  } catch {
    return null;
  }
};

export const messagingServiceWorkerRegistration =
  registerMessagingServiceWorker();
